module.exports = __webpack_public_path__ + "static/media/roller-shutter-spraying.ac27a494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/optimised/roller-shutter-spraying.jpg
// module id = 87
// module chunks = 0